/**
 * @voltxampere/ui — 16x2 character LCD (HD44780) variant (Sprint 43-7, placeholder)
 *
 * PLACEHOLDER. Classic 16-column × 2-row character LCD with the
 * Hitachi HD44780 controller. Real text-rendering + parallel-bus
 * simulation (RS / R/W / EN / D0..D7) arrive Sprint 47+ along with
 * MCU-side LCD driver support.
 *
 * Reference: Hitachi HD44780U + generic 16x2 character LCD. Vcc 5 V,
 * 4-bit or 8-bit parallel bus, optional R/W tri-state.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const displayLcd16x2 = {
    id: "lcd-16x2",
    nameTr: "16x2 Karakter LCD (HD44780, placeholder)",
    nameEn: "16x2 Character LCD (HD44780, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "LCD",
    defaultValue: "LCD-16x2",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=display-lcd-16x2.js.map